import { IContext } from "@src/context";
import { vhmarea, vhmproperty } from "@src/proto/jsonapi";
import { IProperty } from "../types";
import searchDataHelper, { IRCity } from "../../SearchPopup/searchDataHelper";
import singleUrlHelper, { jsonApiPathWithLocale } from "@src/utils/url";

const baseUrl = document.body.getAttribute("data-site-domain") || "";

function fetchPropertiesJson({
  locale,
}: Pick<IContext, "locale">): Promise<vhmproperty.IListProperty[]> {
  const url = `${baseUrl}${jsonApiPathWithLocale("properties", locale)}`;

  // FIXME: extract common json fetcher
  return fetch(url, {
    headers: { Accept: "application/json" },
  })
    .then((response) => {
      if (response.status != 200) {
        throw new Error(
          `Failed to fetch properties json, status: ${response.status} on url ${url}`
        );
      }
      return response.json();
    })
    .then(
      ({ properties }: { properties: vhmproperty.IListProperty[] }) =>
        properties
    );
}

function fetchAreaJson({
  locale,
}: Pick<IContext, "locale">): Promise<vhmarea.IArea> {
  const url = `${baseUrl}${jsonApiPathWithLocale("area", locale)}`;

  // FIXME: extract common json fetcher
  return fetch(url, {
    headers: { Accept: "application/json" },
  })
    .then((response) => {
      if (response.status != 200) {
        throw new Error(
          `Failed to fetch area json, status: ${response.status} on url ${url}`
        );
      }
      return response.json();
    })
    .then((area: vhmarea.IArea) => area);
}

function fetchAllProperties(
  context: Pick<IContext, "locale" | "errorNotifier">
): Promise<IProperty[]> {
  return Promise.all([
    fetchPropertiesJson(context),
    fetchAreaJson(context),
  ]).then(([originProperties, areaJson]) => {
    const cIdRCityMap =
      searchDataHelper.pureConvertAreaResp(areaJson).cIdRCityMap;

    return originProperties.map(
      (property): IProperty => constructProperty(property, cIdRCityMap, context)
    );
  });
}

function constructProperty(
  property: vhmproperty.IListProperty,
  irCityMap: PlainObject<IRCity>,
  { locale, errorNotifier }: Pick<IContext, "locale" | "errorNotifier">
): IProperty {
  const cityId = String(property.cid);
  const irCity = searchDataHelper.getCityWithinParent(cityId, irCityMap);
  let detailLink: string | null;

  if (irCity == null) {
    detailLink = null;
    errorNotifier.notify({
      msg: `fail to construct pdp link for the property from the area json, propertyId: ${property.id}`,
      severity: "warn",
      context: "search map",
    });
  } else {
    detailLink = `${singleUrlHelper.getPDPPrefix(locale)}${irCity.url}/${
      property.path
    }`;
  }

  return {
    ...property,
    detailLink,
    lat: Number(property.lat),
    lng: Number(property.lng),
  };
}

export { fetchAreaJson, fetchPropertiesJson };
export default fetchAllProperties;
